import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'

interface InactiveBrandMessageProps {
  brand: {
    id: string
    brand_name: string
    account_id: string
  }
}

export function InactiveBrandMessage({ brand }: InactiveBrandMessageProps) {
  const navigate = useNavigate()
  
  return (
    <div className="container mx-auto p-8 max-w-2xl">
      <Card className="border-orange-200 bg-orange-50/50">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-orange-900">
            <AlertCircle className="h-5 w-5" />
            Brand Currently Inactive
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-orange-900">
            The brand <strong>"{brand.brand_name}"</strong> is currently inactive because the 
            account owner's subscription has expired or been canceled.
          </p>
          
          <div className="bg-white p-4 rounded-lg border border-orange-200">
            <p className="text-sm font-medium mb-1">What this means:</p>
            <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
              <li>You cannot create or edit content for this brand</li>
              <li>Existing content remains saved but cannot be published</li>
              <li>Brand settings and data are preserved</li>
            </ul>
          </div>
          
          <p className="text-sm text-muted-foreground">
            Please contact the brand owner to request they reactivate their subscription.
            Once reactivated, you'll regain full access to this brand.
          </p>
          
          <div className="flex gap-2 pt-2">
            <Button onClick={() => navigate('/brands')}>
              View Other Brands
            </Button>
            <Button variant="outline" onClick={() => navigate('/profile')}>
              Go to Profile
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}